import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import HomeLayout from '../../layouts/LoginLayout';
import LoginWelcome from '../../components/Simple/LoginWelcome';
import { forgot } from '../../redux/actions/AuthActions';
import { isLoading, errorResponse } from '../../redux/reducers/GlobalReducer';
import { Routes as configRouter } from '../../config/Routes';
import MailBox from '../../assets/img/rich_icons/mailbox.svg';
import LabelR from '../../components/Simple/LabelR';

class ForgotPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resetLinkSent: false,
    };
  }

  setResetLinkSent = () =>
    this.setState({
      resetLinkSent: true,
    });

  handleSubmit = (values, actions) => {
    const { forgot } = this.props;
    forgot({ username: values.email }).then(() => {
      actions.setSubmitting(false);
      this.setResetLinkSent();
    });
  };

  render() {
    const { resetLinkSent } = this.state;
    const { t, isLoading, errorResponse } = this.props;
    return (
      <HomeLayout>
        {(!resetLinkSent || errorResponse) && (
          <Fragment>
            <LoginWelcome title={t('forgotPassTitle')} subtitle={t('forgotPassSubtitle')} />
            <Formik
              initialValues={{ email: '' }}
              onSubmit={(values, actions) => {
                this.handleSubmit(values, actions);
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email(t('validationEmail')).required(t('validationRequired')),
              })}
            >
              {(props) => (
                <form className="px-xl-5" onSubmit={props.handleSubmit}>
                  <div className="form-group">
                    <LabelR htmlFor="loginEmail">{t('labelEmail')}</LabelR>
                    <input
                      type="email"
                      id="forgotPassEmail"
                      className={`form-control ${props.errors.email && props.touched.email && 'is-invalid'}`}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.email}
                      name="email"
                      placeholder={t('placeholderEmail')}
                    />
                    {props.errors.email && <div className="invalid-feedback">{props.errors.email}</div>}
                  </div>
                  <button type="submit" className="form-control btn-global mt-3 text-uppercase text-dark btn-border-radius" disabled={props.isSubmitting}>
                    {isLoading && <FontAwesomeIcon icon="spinner" size="lg" spin className="mx-2" />}
                    {t('forgotPassButton')}
                  </button>
                  <div className="text-center mt-4">
                    <small>
                      {t('forgotPassFooter')}
                      <Link to={configRouter.LOGIN} className="mx-2 classic-link">
                        {t('loginName').toUpperCase()}
                      </Link>
                    </small>
                  </div>
                </form>
              )}
            </Formik>
          </Fragment>
        )}
        {/* Success response */}
        {resetLinkSent && errorResponse === null && (
          <div className="row">
            <div className="col text-center px-xl-5">
              <h1>{t('forgotPassSuccessTitle')}</h1>
              <img src={MailBox} alt="" />
              <p className="px-2 py-3">{t('forgotPassSuccessSubtitle')}</p>
              <Link to={configRouter.HOME} className="btn btn-dark p-2">
                {t('buttonReturn')}
              </Link>
            </div>
          </div>
        )}
      </HomeLayout>
    );
  }
}

ForgotPass.propTypes = {
  forgot: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: isLoading(state),
  errorResponse: errorResponse(state),
});
const mapDispatchToProps = {
  forgot,
};

export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(ForgotPass);
